module.exports = __webpack_public_path__ + "static/img/HAMPTON-MAPLE.c8f39d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMPTON-MAPLE.png
// module id = VnIY
// module chunks = 0